import { createAsyncThunk } from '@reduxjs/toolkit';

import * as F from '../../api/fetchers/promotionsV2/fetcher';
import * as T from '../../api/fetchers/promotionsV2/types/promoFetcher';

export const setPromotionsScreenNameAction = createAsyncThunk(
  'promotionsV2/setPromotionsScreenName',
  (params: T.SetPromotionsScreenNameParams) => {
    return F.setPromotionsScreenName(params);
  }
);

export const fetchPromotionsAction = createAsyncThunk('promotionsV2/fetchPromotions', (params: T.FetchPromoParams) => {
  return F.fetchPromotions(params);
});

export const postPromoConsentAction = createAsyncThunk(
  'promotionsV2/postPromoConsent',
  (params: T.PostPromoConsentParams) => {
    return F.postPromoConsent(params);
  }
);

export const fetchPromotionsPointsAction = createAsyncThunk(
  'promotionsV2/fetchPromotionsPoints',
  (params: T.FetchPromoPointsParams) => {
    return F.fetchPromotionsPoints(params);
  }
);

export const fetchPromotionsJwtAction = createAsyncThunk(
  'promotionsV2/fetchPromotionsJwt',
  (params: T.FetchPromoJwtParams) => {
    return F.fetchPromotionsJwt(params);
  }
);
export const fetchLeaderboardAction = createAsyncThunk(
  'promotionsV2/fetchLeaderboard',
  (params: T.FetchLeaderboardParams) => {
    return F.fetchLeaderboard(params);
  }
);

export const fetchLeaderboardAroundMeAction = createAsyncThunk(
  'promotionsV2/fetchLeaderboardAroundMe',
  (params: T.FetchLeaderboardAroundMeParams) => {
    return F.fetchLeaderboardAroundMe(params);
  }
);

export const fetchPrizesAndWinnersAction = createAsyncThunk(
  'promotionsV2/fetchPrizesAndWinners',
  (params: T.FetchPrizesAndWinnersParams) => {
    return F.fetchPrizesAndWinners(params);
  }
);

export const fetchCashbackScoreAction = createAsyncThunk(
  'promotionsV2/fetchCashbackScore',
  (params: T.FetchCashbackScoreParams) => {
    return F.fetchCashbackScore(params);
  }
);

export const fetchRoundHistoryAction = createAsyncThunk(
  'promotionsV2/fetchRoundHistory',
  (params: T.FetchRoundHistoryParams) => {
    return F.fetchRoundHistory(params);
  }
);

export const fetchRoundHistoryByWSAction = createAsyncThunk(
  'promotionsV2/fetchRoundHistoryByWS',
  (params: T.FetchRoundHistoryParams) => {
    return F.fetchRoundHistoryByWS(params);
  }
);

export const winPromoAckAction = createAsyncThunk('promotionsV2/winPromoAck', (params: T.WinPromoAckParams) => {
  return F.winPromoAck(params);
});
